// extracted by mini-css-extract-plugin
export default {"BlogHeading":"BlogHeading_BlogHeading__tT0Kr"};